/**
 * PublicRoutes
 *
 * Prevents already-authenticated users from landing on public pages (e.g. login).
 * Redirects them to their appropriate home based on their role.
 */
import { Navigate, Outlet } from "react-router-dom";
import useUserStore from "../../store/user";
import { isAdminRole } from "../../permissions";

export const PublicRoutes = () => {
  const { user } = useUserStore();

  if (user) {
    return isAdminRole(user.userType)
      ? <Navigate to="/admin" />
      : <Navigate to="/home" />;
  }

  return <Outlet />;
};
